module.exports = __webpack_public_path__ + "static/historique-82fd4b8782fcf2c726a080220982582b.jpg";